export function svgToPngFromDpi(svgSrc, dpi, onPng) {
    const mmToInches = 25.4;
    const sizeMm = 21;
    const sizePx = Math.round((sizeMm / mmToInches) * dpi);

    svgToPng(svgSrc, sizePx, sizePx, onPng);
}


export function svgToPng(svgSrc, width, height, onPng){
    var img = new Image();
    img.setAttribute('src', svgSrc);
    img.setAttribute('name', 'logo-svg');
    img.setAttribute('width', width);
    img.setAttribute('height', height);
    var canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    canvas.style.width = width;
    canvas.style.height = height;
    var ctxt = canvas.getContext('2d');
    ctxt.clearRect(0, 0, width, height);
    ctxt.fillStyle = "rgba(0, 0, 0, 0)";
    ctxt.fillRect(0,0,width,height);
    img.onload = () => {
        ctxt.drawImage(img, 0, 0, width, height);
        const png = canvas.toDataURL("image/png");
        onPng(png);
    };
}